import React from 'react';
import { motion } from 'framer-motion';
interface MatchStrengthProps {
  percentage: number;
  size?: number;
}
export function MatchStrength({
  percentage,
  size = 60
}: MatchStrengthProps) {
  const radius = size / 2 - 4;
  const circumference = 2 * Math.PI * radius;
  let color = '#eab308'; // yellow
  if (percentage >= 80) color = '#22c55e'; // green
  else if (percentage >= 60) color = '#06b6d4'; // cyan
  return <div className="relative flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-232">
      <svg className="transform -rotate-90 w-full h-full" data-id="element-233">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#1e293b" strokeWidth="4" fill="transparent" data-id="element-234" />
        <motion.circle cx={size / 2} cy={size / 2} r={radius} stroke={color} strokeWidth="4" fill="transparent" strokeDasharray={circumference} initial={{
        strokeDashoffset: circumference
      }} animate={{
        strokeDashoffset: circumference - percentage / 100 * circumference
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} strokeLinecap="round" data-id="element-235" />
      </svg>
      <span className="absolute text-xs font-bold text-white" data-id="element-236">
        {percentage}%
      </span>
    </div>;
}